import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import AccessDeniedIllustration from "../../components/access-denied-illustration";
import SisLogo from "../../components/sis-logo";
import "./styles.scss";

const SOLUCAO_QUERY_PARAM = "solucao";
const SUPORTE_URL = "https://suporte.grupomarista.org.br/";

const NaoAutorizadoPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const nomeSolucao = searchParams.get(SOLUCAO_QUERY_PARAM)?.trim();
  const tituloSolucao = nomeSolucao || "este recurso";

  return (
    <div className="nao-autorizado-page">
      <div className="nao-autorizado-page__illustration">
        <AccessDeniedIllustration />
      </div>

      <div className="nao-autorizado-page__content">
        <h1 className="nao-autorizado-page__title">
          Sem acesso ao {tituloSolucao}
        </h1>

        <p className="nao-autorizado-page__text">
          Você não possui permissão para acessar este recurso.
        </p>

        <p className="nao-autorizado-page__text">
          Entre em contato com o administrador do sistema ou aguarde a liberação do seu acesso.
        </p>

        <p className="nao-autorizado-page__text">
          Se o problema persistir,{" "}
          <a
            href={SUPORTE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="nao-autorizado-page__link"
          >
            clique aqui
          </a>{" "}
          para abrir um chamado.
        </p>

        <div className="nao-autorizado-page__actions">
          <button
            type="button"
            className="nao-autorizado-page__back-button"
            onClick={() => navigate("/painel-central/dashboard")}
          >
            Voltar para aplicações e sistemas
          </button>
        </div>
      </div>

      <div className="nao-autorizado-page__logo">
        <div className="nao-autorizado-page__logo-wrapper">
          <SisLogo />
        </div>
      </div>
    </div>
  );
};

export default NaoAutorizadoPage;
